export default __webpack_public_path__ + "static/media/Ample.cfbce7ff.svg";